import mitt, { Emitter } from "mitt";
import type { CallWebViewAction } from "@/webviewNative/index";

export type Events = {
  // dynamic renderer
  "DR:ResizeMap": any;
  "DR:OpenPreviewImage": any;
  "DR:ToggleLayout": any;

  // 业务事件
  handleThemeConfig: any;
  useMapOnLoad: any;
} & {
  [key in CallWebViewAction]: any;
};

const emitter: Emitter<Events> = mitt<Events>();

export default emitter;
